var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-tab__content",staticStyle:{"padding-top":"3px"}},[_c('ConyForSelect',{model:{value:(_vm.copyForItemList),callback:function ($$v) {_vm.copyForItemList=$$v},expression:"copyForItemList"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }